import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dashboard_card_icon_menu_right",
  "use": "dashboard_card_icon_menu_right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"dashboard_card_icon_menu_right\"><path d=\"m5.774 12.358 4.267-4.266M10.041 8.092 5.774 3.825\" stroke=\"#2D2C34\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol